import { translate } from './translate.helper';

export const formatUser = (user) => {
    if (!user) {
        return translate('global.system');
    }

    return `${user.firstname} ${user.lastname}`;
};
